module.exports = __webpack_public_path__ + "img/SketchPngf4c8fad08f67327d71884c49c25b9f18eb2737bad7e02350ad58e9f7fbcad65d.b7fe3fa5.png";